module.exports = __webpack_public_path__ + "assets/img/C1.73d08596.png";